var TooHot = {};

TooHot.mobileMenu = function()  {

    $('.js-open-menu').click(function(){
      $('.fixed_header').toggleClass('menu_open');
      $('.mobile_menu').toggle();
      $('.menu_logo img').toggleClass('white-bg');
    });
  
  
  $('header.global_header ul.mobile_menu, .grid').on('click', function(event){
    if ($(event.target).closest('.mobile_menu input').length) {
      return false;
    } else {
      
    $('.mobile_menu').hide();
    $('.fixed_header').removeClass('menu_open');
    $('.menu_logo img').removeClass('white-bg');
    }
  });
  
  $('.mob_search').click(function(){
    $('.hidden_search').show();
  });
  
  $('.search_close').click(function(){
    $('.hidden_search').hide();
  });
  



    function handler1() {
      var text = $(this).find('img').attr('src');
      text = text.replace("one-column", "two-column");
      $(this).find('img').attr('src', text);
      $(this).one("click", handler2);
      $('.grid li').addClass('one-per-row');
    }
    function handler2() {
      var text = $(this).find('img').attr('src');
      text = text.replace("two-column", "one-column");
      $(this).find('img').attr('src', text);
      $(this).one("click", handler1);
      $('.grid li').removeClass('one-per-row');
    }
    $('.view_switcher').one('click', handler1);

    }

$('.slideshow').click(function(){
  $('.slideshow_wrapper').addClass('mobile_full');
});

$('.slideshow_close').click(function(){
  $('.slideshow_wrapper').removeClass('mobile_full');
});

    if ($(window).width() < 980) {
      var getMobile = $('.homepage-full-screen').data('mobile');
      var getdesktop = $('.homepage-full-screen').data('desktop');
      $('.homepage-full-screen').css({'background' : 'url(' + getMobile + ')',
                                      '-webkit-background-size' : 'cover',
                                      '-moz-background-size': 'cover',
                                      '-o-background-size': 'cover',
                                      'background-size': 'cover'
                                    })

    }

    $('.item_description p').each(function(){
      var str = $(this).text();
      if (str.startsWith('XS:')) {
        $(this).attr({'data-size' : 'xs'}).addClass('hide-size size-xs');
      } else if (str.startsWith('S:')) {
        $(this).attr({'data-size' : 's'}).addClass('hide-size size-s');
      } else if (str.startsWith('M:')) {
        $(this).attr({'data-size' : 'm'}).addClass('hide-size size-m');
      } else if (str.startsWith('L:')) {
        $(this).attr({'data-size' : 'l'}).addClass('hide-size size-l');
      } else if (str.startsWith('XL:')) {
        $(this).attr({'data-size' : 'xl'}).addClass('hide-size size-xl');
      } else if (str.startsWith('2XL:')) {
        $(this).attr({'data-size' : '2xl'}).addClass('hide-size size-2xl');
      } else if (str.startsWith('3XL:')) {
        $(this).attr({'data-size' : '3xl'}).addClass('hide-size size-3xl');
      }

      if (str.startsWith('OS')) {
        $(this).attr({'data-size' : 'OS'}).addClass('hide-size size-os');
      }

      if (str.startsWith('6:')) {
        $(this).attr({'data-size' : '6'}).addClass('hide-size size-6');
      } else if (str.startsWith('7:')) {
        $(this).attr({'data-size' : '7'}).addClass('hide-size size-7');
      } else if (str.startsWith('8:')) {
        $(this).attr({'data-size' : '8'}).addClass('hide-size size-8');
      } else if (str.startsWith('9:')) {
        $(this).attr({'data-size' : '9'}).addClass('hide-size size-9');
      } else if (str.startsWith('10:')) {
        $(this).attr({'data-size' : '10'}).addClass('hide-size size-10');
      } else if (str.startsWith('11:')) {
        $(this).attr({'data-size' : '11'}).addClass('hide-size size-11');
      } else if (str.startsWith('12:')) {
        $(this).attr({'data-size' : '12'}).addClass('hide-size size-12');
      }


      if (str.startsWith('26:')) {
        $(this).attr({'data-size' : '26'}).addClass('hide-size size-26');
      } else if (str.startsWith('27:')) {
        $(this).attr({'data-size' : '27'}).addClass('hide-size size-27');
      } else if (str.startsWith('28:')) {
        $(this).attr({'data-size' : '28'}).addClass('hide-size size-28');
      } else if (str.startsWith('29:')) {
        $(this).attr({'data-size' : '29'}).addClass('hide-size size-29');
      } else if (str.startsWith('30:')) {
        $(this).attr({'data-size' : '30'}).addClass('hide-size size-30');
      } else if (str.startsWith('31:')) {
        $(this).attr({'data-size' : '31'}).addClass('hide-size size-31');
      } else if (str.startsWith('32:')) {
        $(this).attr({'data-size' : '32'}).addClass('hide-size size-32');
      } else if (str.startsWith('33:')) {
        $(this).attr({'data-size' : '33'}).addClass('hide-size size-33');
      } else if (str.startsWith('34:')) {
        $(this).attr({'data-size' : '34'}).addClass('hide-size size-34');
      } else if (str.startsWith('35:')) {
        $(this).attr({'data-size' : '35'}).addClass('hide-size size-35');
      } else if (str.startsWith('36:')) {
        $(this).attr({'data-size' : '36'}).addClass('hide-size size-36');
      } else if (str.startsWith('37:')) {
        $(this).attr({'data-size' : '37'}).addClass('hide-size size-37');
      } else if (str.startsWith('38:')) {
        $(this).attr({'data-size' : '38'}).addClass('hide-size size-38');
      } else if (str.startsWith('39:')) {
        $(this).attr({'data-size' : '39'}).addClass('hide-size size-39');
      } else if (str.startsWith('40:')) {
        $(this).attr({'data-size' : '40'}).addClass('hide-size size-40');
      }


      if (str.startsWith('Condition: ')) {
        $(this).addClass('item_desc hide-size');
      }

    });

    $('.product_sizes ul input').click(function(){
      var getSize = $(this).data('size');
      if (getSize !== "" && !$.isNumeric(getSize)) {
        var theSize = getSize.toLowerCase();
      } else {
        var theSize = getSize;
      }

      var putSize = $('.size-' + theSize ).text();
      $('.size_description').text(putSize);
      var sizedata = $('.size_description');  
      sizedata.html( sizedata.text().replace(/(^\w+)/,'<strong>$1</strong>') ); 
    });

    var getCondition = $('.item_desc').text();
    var count = $('.product_sizes ul input').size();
    $('.condition_description').text(getCondition);

    if ( count  ==  1 ) {
      var getSize = $('.product_sizes ul input').data('size');
      var getCondition = $('.item_desc').text();
      if (getSize !== "" && !$.isNumeric(getSize)) {
        var theSize = getSize.toLowerCase();
      } else {
        var theSize = getSize;
      }
      var putSize = $('.size-' + theSize ).text();
      $('.product_sizes ul input').attr("checked", "checked");
      $("input[type='submit']").removeAttr("disabled");
      $('.size_description').text(putSize);
    } else {
      $('.size_description').text('Size: Choose a size option');
    } 

  

  		 // On call to IPGeolocation API on each page during a user's visit, API response will be served from sessionStorage after the first page.
        _ipgeolocation.enableSessionStorage(true);

        var ip = sessionStorage.getItem("ip");
        var continent_code = sessionStorage.getItem("continent_code");
        var country_code2 = sessionStorage.getItem("country_code2");
        var currency = sessionStorage.getItem("currency");
        var before = sessionStorage.getItem("before");

        if (!ip || !continent_code || !country_code2 || !currency) {
            _ipgeolocation.makeAsyncCallsToAPI(false);
            _ipgeolocation.setFields("continent_code,country_code2,currency");
            _ipgeolocation.getGeolocation(handleResponse, "18de082c74344ab1b8c6af4a144adb3e");
        }

        function handleResponse(json) {
            ip = json.ip;
            continent_code = json.continent_code;
            country_code2 = json.country_code2;
            currency = json.currency;
        }

//    		if ( country_code2 == 'GB' ) {
//             $('.notax').hide()
//             $('.withtax').show();
//         } else {
//             $('.notax').show()
//             $('.withtax').hide()
//         }

        if (before == null) {
            sessionStorage.setItem('before', true);
          	window.location = "?currency=" + currency.code;
        } else {
        }
  

    var pdata = $('.size_description');  
    pdata.html( pdata.text().replace(/(^\w+)/,'<strong>$1</strong>') ); 
    var condata = $('.condition_description');  
    condata.html( condata.text().replace(/(^\w+)/,'<strong>$1</strong>') ); 

    $('body').click(function(){

      var $item = $(".grid li");

      // On ALT+L event

      if ($(window).width() < 480) {
        if ($item.hasClass("one-per-row")) {
            $item.addClass("one-per-row");
            window.localStorage.hasLightClass = true;
        } else {
            window.localStorage.hasLightClass = false;
            $item.removeClass("one-per-row");
        }
      }

    });


      var $item = $(".grid li");
      // On page load
      var hasClass = window.localStorage.hasLightClass || false;
      if (JSON.parse(hasClass)) {
        $item.addClass("one-per-row");
      }










TooHot.index = {

  initialize: function() {
    this.superslider();
    this.lazyMuhFucka();
  },

  superslider: function() {
    $('#slides').superslides({
      animation: 'fade',
      play: '5000'
    });
  },
  
  lazyMuhFucka: function() {
    if ($(window).width() > 980) {
      $(".lazy").lazyload({
        effect: "fadeIn",
        threshold : 400
      });
    }
    
//     $('.about-link').click(function(){
//       $('.sidebar').css({'left': '0px'});
//     });
    $('.global-header ul li:nth-child(3)').click(function(){
      $('.sidebar').toggleClass('move-in-view');
      $('.sidebar-overlay').toggleClass('showhide');
      $('body').toggleClass('lock-body');
      $('.side-close').toggleClass('close-move');
    });
    $('.sidebar-overlay').click(function(){
      $('.sidebar').toggleClass('move-in-view');
      $('.sidebar-overlay').toggleClass('showhide');
      $('body').toggleClass('lock-body');
      $('.side-close').toggleClass('close-move');
    });
    $('.side-close').click(function(){
      $('.sidebar').toggleClass('move-in-view');
      $('.sidebar-overlay').toggleClass('showhide');
      $('body').toggleClass('lock-body');
      $('.side-close').toggleClass('close-move');
    });
    
    $('.index-size').each(function(){
    var str = $(this).html();
  var newStr = $.trim(str).slice(0,-1);
    $(this).html(newStr);
    });
    
    
    function onHover() {
      $(this).children().children('.product-overlay').fadeIn(100);  
    }

    function offHover() {
      $(this).children().children('.product-overlay').fadeOut(100)
    }
    
    if ($(window).width() > 980) {
    var $selectedLink = $(".prod-image-wrap");

    $selectedLink.hoverIntent({
        over: onHover,
        out: offHover
    });
    }
    
   
    
    
//     $('.second').after('<li>.</li>');
    
    
   
  }
  

}

TooHot.productPage = function() {
  // Get height of #product-photo-container, apply correct height to #product-details-inner
  if ($(window).width() > 980) {
    var imageHeight = $('#product-photo-container').outerHeight();
    $('#product-details-inner').css('height', imageHeight);
  }
}

TooHot.terms = function() {
  
  $('ul.global-nav li:nth-child(2)').addClass('second');
  $('ul.global-nav li:nth-child(3) a').removeAttr('href');

}

TooHot.addToCart = function() {
  $('#add-to-cart').submit(function(event) {

    $('body').css('cursor', 'progress');
    howMany = $('input').data('max');

    event.preventDefault();
    var action = $(this).attr('action');

    $.ajax({
        url: action,
        type: 'POST',
        data: $('#add-to-cart').serialize(),
        dataType: 'json',
        success: addToCartOk,
        error: addToCartFail
    });

  });

  $(function(){
    $("input[type='radio']").change(function(){
        $("input[type='submit']").removeAttr("disabled");
    });
});

  statusBox   = $('.cart-status-bro'),
  statusH1    = statusBox.find('h1');

  function constants(message) {
    var addedToCart = $('.added-to-cart'),
        messageBox    = '<div class="message"><h3>'+ message +'</h3></div>';

    addedToCart.fadeIn('fast').append(messageBox);

    setTimeout(function(){
      addedToCart.fadeOut('fast');
    }, 2000);
    
    jQuery.getJSON('/cart.js', function(cart) {
  		$('.work').html(cart.item_count);
	});

    $('body').css('cursor', 'auto');
  }

  function addToCartOk(product) {
    var successMessage = 'Added to cart'
    constants(successMessage); 
    $('input').attr("disabled", "disabled").addClass('disabled');
  }

  function addToCartFail(obj, status) {
    var failMessage = 'Already in Cart'
    constants(failMessage); 
  }
}

TooHot.productImages = {

  initialize: function() {
    this.thumbs();
    this.slideshow();
  },

  preloadThumbs: function() {
    if ($(window).width() > 780) {
      var preloadImgs = [];
      $(".product-photo-thumb img").each(function() {
        var img = new Image();
        img.src = $(this).data("src");
        preloadImgs.push(img);
      });
    }
  },

  thumbs: function() {

    $('.product-photo-thumb').each(function(index){
      $(this).attr('data-number', index);
      var slideToStartOn = index

      var thisThumbDataSrc = $(this).find('img').data('src');

      $(this).on('click', function(){
        var getBigContainer = $('#product-photo-container').find('img');
        getBigContainer.attr('src', thisThumbDataSrc);
        getBigContainer.attr('data-slideshow-start', slideToStartOn)
      });
    });
    
  },

  thumbsWidth: function() {
    var el = $('#product-photo-container img').width();
    $('.thumbs-rapper, #product-photo-thumbs').css('width', el);
  },

  slideshow: function() {
    $('.more-than-one-image img').on('click', function(){
      
      $('.slideshow_wrapper').fadeIn('fast');
      $('body').css('overflow', 'hidden');

      var getSlideNumber = $(this).data('slideshow-start'); 

      $('.slideshow').cycle({
        fx: 'fade',
        startingSlide: getSlideNumber
      });
      
      $('#slideshow').find('script[type="text/html"]').each(function() {
        $(this).replaceWith( $(this).html() );
      });

    });

    if ($(window).width() > 780) {
      $('.slideshow-thumb').on('click', function(event) {
        if ($(event.target).closest('.next, .prev').length) {
          return false;
        } else {
          $('.slideshow_wrapper').fadeOut('fast', function(){
            $('.slideshow').cycle('destroy');
          });
          $('body').css('overflow', 'visible');
        }
      });
    }
  }

},

TooHot.cart = {
  initialize: function() {
    this.footer();
    // this.ifInCart();
  },

  footer: function() {
    if ($(".empty-cart").length > 0){
      $('.global-footer').css('position', 'absolute');
      $('.nav-item a').css('color', 'white');
    }
  },

  ifInCart: function() {
    var getThatCart = Shopify.getCart()
    $('body').append(getThatCart);
  }
},

TooHot.info = {
  
  initialize: function() {
    this.font();
  },

  font: function() {
    $(".wrapme, .message").fitText();
  }

},

TooHot.responsive = {

  initialize: function() {
    this.grid();
    this.productImages();
  },

  grid: function() {
    var grid  = $('.grid');
    var img   = grid.find('img');

    if ($(window).width() > 980) {
      img.each(function(){
        var imgData = $(this).data('original');
        $(this).attr('src', imgData);
      });
    }

    if ($(window).width() < 780) {
      img.each(function(){
        var imgData = $(this).data('medium');
        $(this).attr('src', imgData);
      });
    }

    if ($(window).width() < 500) {
      img.each(function(){
        var imgData = $(this).data('small');
        $(this).attr('src', imgData);
      });
    }
  },

  productImages: function() {

    // Below 780, do not load big images
    if ($(window).width() > 780) {
      var img = $('.more-than-one-image img')
      var imgData = img.data('desktop');
      img.attr('src', imgData);
    }

    if ($(window).width() < 780) {

      var img   = $('.slideshow_wrapper').find('img');

      img.each(function(){
        var imgData = $(this).data('mobile');
        $(this).attr('src', imgData);
      });

      $('#slideshow').find('script[type="text/html"]').each(function() {
        $(this).replaceWith( $(this).html() );
      });

      $('.slideshow_wapper').show();

      $('.slideshow').cycle({
        swipe: true
        // fx: 'scrollHorz'
      });

    }
  }
}

   

// On ready
$(function(){
  TooHot.mobileMenu();
  TooHot.index.initialize();
  TooHot.addToCart();
  TooHot.productPage();
  TooHot.terms();
  TooHot.productImages.initialize();
  TooHot.productImages.thumbsWidth();
  TooHot.cart.initialize();
  TooHot.info.initialize();
  TooHot.responsive.initialize();
});

// On load
$(window).load(function(){
  setTimeout(TooHot.productImages.preloadThumbs(), 5000);
  TooHot.productImages.thumbsWidth();
});

// On resize
$(window).resize(function(){
  TooHot.productPage();
  TooHot.productImages.thumbsWidth();
  TooHot.responsive.initialize();
});
